<svg
  class="landing-inversores__icon"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  [ngSwitch]="name"
>
  <ng-container *ngSwitchCase="'check'">
    <polyline points="20 6 9 17 4 12"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'lock'">
    <rect x="4" y="10" width="16" height="10" rx="2"></rect>
    <path d="M7 10V7a5 5 0 0 1 10 0v3"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'zap'">
    <polygon points="12 2 4 14 11 14 10 22 20 9 13 9 12 2"></polygon>
  </ng-container>

  <ng-container *ngSwitchCase="'pen'">
    <path d="M17 3a2.83 2.83 0 1 1 4 4L7 21l-4 1 1-4Z"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'users'">
    <circle cx="9" cy="8" r="3.5"></circle>
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0"></path>
    <path d="M16 6.5c1.66 0 3 1.34 3 3s-1.34 3-3 3"></path>
    <path d="M18.5 20a5.5 5.5 0 0 0-4-5.3"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'trending-up'">
    <polyline points="3 17 10 10 14 14 21 6"></polyline>
    <polyline points="15 6 21 6 21 12"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'home'">
    <path d="M3 11.5 12 4l9 7.5"></path>
    <path d="M5.5 10v9.5A1.5 1.5 0 0 0 7 21h10a1.5 1.5 0 0 0 1.5-1.5V10"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'award'">
    <circle cx="12" cy="8" r="5.5"></circle>
    <path d="M8.5 12.5 7 21l5-2.5L17 21l-1.5-8.5"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'arrow-up-right'">
    <line x1="6" y1="18" x2="18" y2="6"></line>
    <polyline points="8 6 18 6 18 16"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'calculator'">
    <rect x="5" y="3" width="14" height="18" rx="2"></rect>
    <line x1="8" y1="7" x2="16" y2="7"></line>
    <line x1="8" y1="12" x2="8" y2="12.01"></line>
    <line x1="12" y1="12" x2="12" y2="12.01"></line>
    <line x1="16" y1="12" x2="16" y2="12.01"></line>
    <line x1="8" y1="16" x2="8" y2="16.01"></line>
    <line x1="12" y1="16" x2="12" y2="16.01"></line>
    <line x1="16" y1="16" x2="16" y2="16.01"></line>
  </ng-container>

  <ng-container *ngSwitchCase="'clipboard-check'">
    <rect x="6" y="4" width="12" height="17" rx="2"></rect>
    <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"></path>
    <polyline points="9 13 11 15 15 10.5"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'building'">
    <rect x="5" y="2.5" width="14" height="19" rx="1"></rect>
    <line x1="9" y1="7" x2="9" y2="7.01"></line>
    <line x1="15" y1="7" x2="15" y2="7.01"></line>
    <line x1="9" y1="11" x2="9" y2="11.01"></line>
    <line x1="15" y1="11" x2="15" y2="11.01"></line>
    <line x1="9" y1="15" x2="9" y2="15.01"></line>
    <line x1="15" y1="15" x2="15" y2="15.01"></line>
    <line x1="10" y1="21.5" x2="10" y2="18" data-part="door-a"></line>
    <line x1="14" y1="21.5" x2="14" y2="18" data-part="door-b"></line>
  </ng-container>

  <ng-container *ngSwitchCase="'database'">
    <ellipse cx="12" cy="5.5" rx="7" ry="3"></ellipse>
    <path d="M5 5.5V12c0 1.66 3.13 3 7 3s7-1.34 7-3V5.5"></path>
    <path d="M5 12v6.5c0 1.66 3.13 3 7 3s7-1.34 7-3V12"></path>
  </ng-container>

  <ng-container *ngSwitchCase="'shield-check'">
    <path d="M12 2.5 19 5.5v6c0 5-3 8.2-7 10-4-1.8-7-5-7-10v-6Z"></path>
    <polyline points="9 12 11 14 15.5 9.5"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'clock'">
    <circle cx="12" cy="12" r="9"></circle>
    <polyline points="12 7 12 12 16 14"></polyline>
  </ng-container>

  <ng-container *ngSwitchCase="'star'">
    <polygon
      points="12 2.5 15.09 8.85 22 9.85 17 14.72 18.18 21.6 12 18.35 5.82 21.6 7 14.72 2 9.85 8.91 8.85 12 2.5"
    ></polygon>
  </ng-container>

  <ng-container *ngSwitchCase="'chevron-down'">
    <polyline points="6 9 12 15 18 9"></polyline>
  </ng-container>
</svg>
